/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Report_Invite_BodyInputs */



/**
* | output |
* | --- |
* | "Wundo couldn't follow this conversation. Share your own notes and Wundo turns them into a report." |
*
* @param {Meeting_Report_Invite_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_report_invite_body = /** @type {((inputs?: Meeting_Report_Invite_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Report_Invite_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo kon dit gesprek niet volgen. Deel je eigen notities en Wundo maakt er een verslag van.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo n'a pas pu suivre cette conversation. Partagez vos propres notes et Wundo en fait un compte rendu.")
	return /** @type {LocalizedString} */ ("Wundo couldn't follow this conversation. Share your own notes and Wundo turns them into a report.")
});